import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ODataParams, ODataResponse } from '@tdw/core';
import { ENV_CONFIG, EnvironmentConfig } from 'src/environments/environment.model';
import { LookupValue } from '../models/lookup.model';
import { Observable, map } from 'rxjs';
import { Application, PEEquipmentProduct, PEEquipmentFamily, PEFitting, PEFilter, Measurement, PEFittingProduct } from '../models';

@Injectable({
  providedIn: 'root'
})
export class PeService {

  private endpoint: { url: string; version: string; };

  constructor(
    private http: HttpClient,
    @Inject(ENV_CONFIG) private config: EnvironmentConfig) {
    this.endpoint = this.config.endpoints.baseApi;
  }

  getPipeSizes(q: ODataParams): Observable<ODataResponse<LookupValue[]>> {
    return this.http.get<ODataResponse<LookupValue[]>>(`${this.endpoint?.url}odata/${this.endpoint?.version}/PEPipeSizes${q.toQuery()}`);
  }

  loadPEFittingProducts(q: ODataParams): Observable<ODataResponse<PEFittingProduct[]>> {
    return this.http.get<ODataResponse<PEFittingProduct[]>>(`${this.endpoint.url}odata/${this.endpoint.version}/PEFittingProducts${q.toQuery()}`);
  }

  loadEquipmentFamilies(q: ODataParams): Observable<ODataResponse<PEEquipmentFamily[]>> {
    return this.http.get<ODataResponse<PEEquipmentFamily[]>>(`${this.endpoint.url}odata/${this.endpoint.version}/PEEquipmentFamilies/${q.toQuery()}`);
  }

  loadEquipment(q: ODataParams): Observable<ODataResponse<PEEquipmentProduct[]>> {
    return this.http.get<ODataResponse<PEEquipmentProduct[]>>(`${this.endpoint.url}odata/${this.endpoint.version}/PEEquipmentProducts${q.toQuery()}`)
  }

  loadReport(reportType: 'Excel' | 'pdf', fittingPartNumbers: string, equipmentPartNumbers: string, accessoryPartNumbers: string): Observable<Blob> {
    const body: any = { reportType };

    if (fittingPartNumbers.length > 0) body.fittingPartNumbers = fittingPartNumbers;
    if (equipmentPartNumbers.length > 0) body.equipmentPartNumbers = equipmentPartNumbers;
    if (accessoryPartNumbers.length > 0) body.accessoryPartNumbers = accessoryPartNumbers;
    const contentType = reportType === 'Excel' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'application/pdf';

    return this.http.post<ArrayBuffer>(`${this.endpoint.url}api/${this.endpoint.version}/PEProducts/Report`,
      body,
      { responseType: 'arraybuffer' as 'json' })
      .pipe(map(res => new Blob([new Uint8Array(res, 0, res.byteLength)], { type: contentType })))
  }
}
